module.exports = __webpack_public_path__ + "static/media/news-wten.60d2fba6.jpg";